<template>
    <div v-show="visible">
        <!-- 下载评价模板弹出框 -->
        <el-dialog title="模板评价" :close-on-click-modal="false" :visible.sync="visible" width="430px" style="text-align: center;">
            <el-button type="primary" icon="search" @click="showDownloadTemplateDialog">下载评价模板</el-button>
            <el-button type="primary" icon="search" @click="triggerFileUpload">导入评价模板</el-button>
            <input type="file" ref="fileInput" style="display: none" @change="handleFileChange" accept=".xls,.xlsx">
            <div style="font-size: 12px; color:red; text-align: left; margin-top: 10px;">注：通过Excel模版的导入评价方式，可快速的实现对学生、班级、教职的批量评价。适用于德育负责、行政负责、科任教师在事后或者周期的方式通过电脑来导入评价数据的应用场景。</div>
        </el-dialog>
        <!-- 下载评价模板弹出框 -->
        <download-template-dialog ref="downloadTemplateDialog"></download-template-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../../common/http';
    import downloadTemplateDialog from './DownloadTemplateDialog.vue';

export default {
    name: "myEvaluatePanel",
    data() {
        return {
            visible: false,
        }
    },
    components: {
        downloadTemplateDialog,
    },
    created() {
    },
    methods: {
        showDialog() {
            this.visible = true
        },
        // 关闭弹窗
        closeDialog() {
            this.visible = false
        },
        // 显示下载评价模板弹窗
        showDownloadTemplateDialog() {
            this.$nextTick(() => {
                this.$refs['downloadTemplateDialog'].showDialog()
            })
        },
        // 触发文件选择框
        triggerFileUpload() {
            this.$refs.fileInput.click()
        },
        // 处理文件选择变化
        handleFileChange(e) {
            const file = e.target.files[0]
            if (!file) return
            
            // 验证文件类型
            let fileType = file.type;
            let isLt2M = file.size / 1024 / 1024 < 100;
            
            if (this.$constant.excelFileType.indexOf(fileType) == -1) {
                this.$commonFn.showTip('导入文件只支持.xls与.xlsx', 3);
                return;
            }

            if (!isLt2M) {
                this.$commonFn.showTip('文件大小不能超过100MB!', 3);
                return;
            }
            
            // 显示加载中
            const loadingInstance = this.$loading({ 
                text: '正在导入数据，请稍候', 
                spinner: 'el-icon-loading', 
                background: 'rgba(0, 0, 0, 0.7)' 
            });
            
            // 获取用户信息
            let userinfo = JSON.parse(sessionStorage.getItem('userinfo'))
            
            // 创建表单数据
            let uploadForm = new FormData()
            uploadForm.append('file', file)
            uploadForm.append('deptId', userinfo.deptId)
            
            // 发送请求
            this.$axios.post(this.evaluateDetailImportTemplateUrl, uploadForm).then((res) => {
                if (res.data.status == 200) {
                    this.$commonFn.showTip(res.data.message, 5, true)
                    this.$parent.getData()
                } else {
                    this.$commonFn.showTip(res.data.message, 4, true)
                }
                loadingInstance.close();
                // 重置文件输入框，以便再次选择同一文件
                this.$refs.fileInput.value = ''
            }, (err) => {
                console.log(err);
                loadingInstance.close();
                this.$refs.fileInput.value = ''
            })
        },
    },
    mixins: [http]
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/MyEvaluatePanel.vue